import { lazy } from "react";
import { Navigate } from "react-router-dom";

const HomeLayout = lazy(() => import("../layouts/HomeLayout.jsx"));

const HomeView = lazy(() => import("../views/home/HomeView.jsx"));

const ThemeRoutes = [
    {
         path: "/",
        element: <HomeLayout />,
        children: [
            { path: "", exact: true, element: <HomeView /> },
        ]
    }
        
]
export default ThemeRoutes;